'use client'
import { useState } from 'react'
import CommonNav from '../commonNav'

function Partnership({ graphData, is100, theme, className, hideTabs, selected, title }: any) {
  const pillsData: any = []
  graphData.sort((a: any, b: any) => {
    return a.nInningNumber - b.nInningNumber
  })
  graphData.forEach((item: any) =>
    pillsData.push({
      value: item.sName,
      navItem: `${item.sName.replace('Inning', '')}: ${item.nRuns || '0'} / ${item.nWickets || '0'} (${
        is100 ? item?.sBalls : item.sOvers || '0'
      })`
    })
  )
  const [activeTab, setActiveTab] = useState(pillsData[0])

  const inningsData: any = []

  graphData.forEach((data: any) => inningsData.push(data.aPartnership))

  const selectedIndex = pillsData.findIndex((ele: any, index: number) => {
    return (selected >= 0 ? index : ele.value) === (selected ?? activeTab.value)
  })

  const data = inningsData[selectedIndex]?.map((ele: any) => {
    const leftShortName =
      `${ele.aBatsmen[0].oBatter?.sShortName?.split(' ')?.[0]?.[0] || ''} ${ele.aBatsmen[0].oBatter?.sShortName?.split(' ')?.[1]}` ||
      ''
    const rightShortName =
      `${ele.aBatsmen[1].oBatter?.sShortName?.split(' ')?.[0]?.[0] || ''} ${ele.aBatsmen[1].oBatter?.sShortName?.split(' ')?.[1]}` ||
      ''

    function calculatePercentage(runs: number, totalRuns: number) {
      return totalRuns > 0 ? ((runs / totalRuns) * 100).toFixed(2) : 0
    }
    const leftSideRuns =
      calculatePercentage(ele.aBatsmen[0].nRuns, ele.aBatsmen[0].nRuns + ele.aBatsmen[1].nRuns) || 0
    const rightSideRuns =
      calculatePercentage(ele.aBatsmen[1].nRuns, ele.aBatsmen[0].nRuns + ele.aBatsmen[1].nRuns) || 0
    return (
      <div
        key={ele.nOrder}
        className="flex justify-between border-b border-b-c sm:border-b sm:border-b-c sm:mb-2.5 text-t-light sm:text-t-origin"
      >
        <span className="min-w-[70px] w-20 sm:min-w-[160px] sm:w-40 text-textOffWhite flex flex-col-reverse sm:flex-row items-start md:items-center justify-start text-xs md:text-sm font-medium text-ellipsis overflow-hidden whitespace-nowrap text-start">
          <span className="block me-1">
            {`${ele.aBatsmen[0].nRuns} (${ele.aBatsmen[0].nBallFaced}) `}{' '}
          </span>
          {`${leftShortName || '-'}`}
        </span>

        <div className="flex flex-col justify-around py-2 sm:pt-0 text-t-origin text-xs font-bold items-center w-full">
          <span className="mb-1">{`${ele.nRuns} (${ele.nBallFaced})`}</span>
          <div className="!gap-0 w-full sm:h-full flex">
            <div className="flex h-full w-full">
              <div
                className={`${rightSideRuns && Number(rightSideRuns) > 0 ? 'rounded-l-sm' : 'rounded-sm'} h-2 flex items-center text-sm font-bold justify-end text-transparent sm:text-t-origin`}
                style={{
                  width: `${leftSideRuns}%`,
                  background: theme === 'light' ? '#B1D98C' : '#7FC142'
                }}
              ></div>
              <div
                className={`${leftSideRuns && Number(leftSideRuns) > 0 ? 'rounded-r-sm' : 'rounded-sm'} h-2 flex items-center text-sm font-bold text-transparent sm:text-t-origin`}
                style={{
                  width: `${rightSideRuns}%`,
                  background: theme === 'light' ? '#CA687F' : '#802D41'
                }}
              ></div>
            </div>
          </div>
        </div>

        <span className="min-w-[70px] w-20 sm:min-w-[160px] sm:w-40 text-textOffWhite flex flex-col sm:flex-row items-end md:items-center justify-end text-xs md:text-sm font-medium text-ellipsis overflow-hidden whitespace-nowrap ">
          {`${rightShortName || '-'}`}
          <span className="block ms-1">{`${ele.aBatsmen[1].nRuns} (${ele.aBatsmen[1].nBallFaced})`}</span>
        </span>
      </div>
    )
  })

  return (
    <div
      className={`w-full md:!-my-4 md:!py-4 md:-mx-4 md:px-4 md:border-borderStroke md:border md:rounded-2xl md:bg-headersActive overflow-x-auto ${className || ''}`}
    >
      {title ? (
        <h4 className="mt-0 md:mt-2 text-xl text-textDselected mb-2 md:mb-4">{title}</h4>
      ) : null}
      {!hideTabs ? (
        <CommonNav
          items={pillsData}
          variant="pills"
          asButton
          className="my-3 !font-bold justify-start"
          tabClassName="!text-xs !font-medium h-9 !leading-3"
          onTabChange={setActiveTab}
          isActive={item => item?.value === activeTab.value}
        />
      ) : null}
      {data}
    </div>
  )
}

export default Partnership
